<template>
  <div id="contenedor-main-contrato-archivos-contratista">
    <v-card flat>
      <v-card-text>
        <!-- ToolBar -->
        <tool-bar
          v-if="!$apollo.queries.contratoArchivosContratista.loading"
          :soloLectura="soloLectura"
          class="my-3"
          v-on:agregarArchivo="agregarNuevoArchivo"
          v-on:abrirTiposArchivos="mostrarCatalogoTiposArchivos = true"
        >
        </tool-bar>
        <v-divider v-if="!soloLectura"></v-divider>
        <!-- Loader -->
        <v-skeleton-loader
          v-if="$apollo.queries.contratoArchivosContratista.loading"
          type="table-heading, table-thead, table-tbody"
        >
        </v-skeleton-loader>
        <listado
          v-if="
            !$apollo.queries.contratoArchivosContratista.loading && getListadoArchivos.length > 0
          "
          :listadoArchivos="getListadoArchivos"
          :soloLectura="soloLectura"
        >
        </listado>
        <!-- Mensaje de alertar de que no existen archivos registrados -->
        <v-row v-else justify="center" align="center">
            <v-alert class="mt-4" type="info"> No se encontraron registros. </v-alert>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- Agregar archivo -->
    <v-dialog v-if="mostrarAgregarArchivo" v-model="mostrarAgregarArchivo" width="450">
      <agregar-archivo :idContrato="idContrato" v-on:cerrar="cerrarVentana"> </agregar-archivo>
    </v-dialog>
    <!-- Borrar archivo -->
    <v-dialog v-model="mostrarEliminarArchivo" width="450">
      <eliminar-archivo
        v-if="esteArchivo"
        :contratoArchivoContratistaEliminar="esteArchivo"
        v-on:cerrar="cerrarVentana"
      >
      </eliminar-archivo>
    </v-dialog>
    <v-dialog
      v-if="mostrarCatalogoTiposArchivos"
      v-model="mostrarCatalogoTiposArchivos"
      width="800">
      <v-card>
        <v-card-title class="secondary--text">
          Tipos de Archivos
            <v-spacer></v-spacer>
            <v-btn icon @click="mostrarCatalogoTiposArchivos = !mostrarCatalogoTiposArchivos">
              <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
          </v-card-title>
        <v-card-text>
          <CatalogoTiposArchivosContratista />
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mostrarNotificarArchivo" width="450">
      <v-card>
        <v-card-title>
          Notificar Nuevo Archivo
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrarVentana">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 400px; overflow: auto;">
          <Directorio v-model="contactos" :id-contrato="$route.params.idContrato"></Directorio>
        </v-card-text>
        <v-divider class="mx-3"></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="notificar" color="primary" depressed rounded>
            <v-icon left small>
              mdi-send
            </v-icon>
            Enviar notificación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO_ARCHIVOS_CONTRATISTA from '@/graphql/querys/administracion/contratos/contrato/archivos-contratista/contratoArchivosContratista.gql';
import AgregarArchivo from '@/components/administracion/contratos/contrato/archivoscontratista/Agregar.vue';
import EliminarArchivo from '@/components/administracion/contratos/contrato/archivoscontratista/Eliminar.vue';
import CatalogoTiposArchivosContratista from '@/views/contratistas/contratos/contrato/archivoscontratista/configuracion/tipos-archivos/Main.vue';
import eventBus from '@/helpers/eventBus';
import Directorio from '@/components/administracion/contratos/contrato/directorios/Directorio.vue';
import mixSendEmail from '@/helpers/mixSendEmail';
import ToolBar from './ToolBar.vue';
import listado from './listado/Listado.vue';

export default {
  name: 'MainContratoFrentes',
  mixins: [mixSendEmail],
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    ToolBar,
    AgregarArchivo,
    Directorio,
    EliminarArchivo,
    listado,
    CatalogoTiposArchivosContratista,
  },
  data() {
    return {
      contactos: [],
      idContrato: this.$route.params.idContrato,
      mostrarCatalogoTiposArchivos: false,
      mostrarAgregarArchivo: false,
      mostrarEditarArchivo: false,
      mostrarEliminarArchivo: false,
      mostrarNotificarArchivo: false,
      esteArchivo: null,
    };
  },
  mounted() {
    eventBus.$on('descargar-archivo', (archivo) => {
      console.log('descargar archivo', archivo);
    //   this.esteArchivo = archivo;
    //   this.mostrarEditarArchivo = true;
    });
    eventBus.$on('eliminar-archivo', (archivo) => {
      this.esteArchivo = archivo;
      this.mostrarEliminarArchivo = true;
    });
    eventBus.$on('notificar-archivo', (archivo) => {
      this.esteArchivo = archivo;
      this.mostrarNotificarArchivo = true;
    });
  },
  apollo: {
    contratoArchivosContratista: {
      query: CONTRATO_ARCHIVOS_CONTRATISTA,
      variables() {
        return {
          idContrato: this.idContrato,
        };
      },
    },
  },
  methods: {
    async notificar() {
      if (this.contactos.length === 0) {
        this.mixMensajeError('No hay contactos seleccionados');
        return;
      }
      const numeroContrato = this.esteArchivo.contrato.numero || 'desconocido';
      await this.mixSendEmail({
        to: this.contactos,
        subject: `📄 ${numeroContrato} Nuevo Archivo disponible en el sistema SIDEOP`,
        text: '',
        html: this.emailBodyText,
      });

      this.contactos = [];
    },
    agregarNuevoArchivo() {
      this.mostrarAgregarArchivo = true;
    },
    cerrarVentana() {
      this.mostrarAgregarArchivo = false;
      this.mostrarEditarArchivo = false;
      this.mostrarEliminarArchivo = false;
      this.mostrarNotificarArchivo = false;
      this.esteArchivo = null;
      this.contactos = [];
    },
  },
  computed: {
    getListadoArchivos() {
      if (!this.contratoArchivosContratista) return [];
      return this.contratoArchivosContratista.map((archivo) => ({
        ...archivo,
        datosArchivo: JSON.parse(archivo.fileData),
        descargandoArchivo: false,
      }));
    },
    emailBodyText() {
      if (!this.esteArchivo) return '';
      return `
        <p>Hola,</p>
        <p>Te informamos que se ha anexado un nuevo Archivo al contrato ${this.esteArchivo.contrato.numero}.</p>
        <p>Puedes consultarlo ingresando a la plataforma en la sección correspondiente.</p>
        <br/>
        <p><b></b>Detalles del archivo:</b></p>
        <ul>
          <li><b>Nombre del archivo:</b> ${this.esteArchivo.descripcion}</li>
          <li><b>Tipo de archivo:</b> ${this.esteArchivo?.tipoArchivo?.descripcion}</li>
          <li><b>Clase:</b> ${this.esteArchivo.datosArchivo.extension}</li>
          <li><b>Fecha de carga:</b> ${new Date(this.esteArchivo.createdAt).toLocaleDateString()}</li>
        </ul>
        <p>Saludos</p>
      `;
    },
  },
};
</script>

<style lang="scss"></style>
